import { Link } from "react-router-dom";
import { Reveal, Label } from "@/components/motion";
import { DESTINATIONS } from "@/data/site";

function Card({ d, large, offset }) {
  return (
    <Link
      to={`/destinations/${d.slug}`}
      data-testid={`destination-card-${d.slug}`}
      className={`group block ${offset ? "lg:mt-28" : ""}`}
    >
      <div className={`overflow-hidden ${large ? "aspect-[16/11]" : "aspect-[4/5]"}`}>
        <img
          src={d.cardImage}
          alt={d.name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.04]"
        />
      </div>
      <div className="mt-7 flex items-start justify-between gap-6">
        <div>
          <p className="label text-gold">{d.region}</p>
          <h3 className="mt-3 font-serif text-3xl font-light tracking-tight text-white sm:text-4xl">
            {d.name}
          </h3>
          <p className="mt-3 max-w-md text-[15px] leading-relaxed text-white/60">{d.tagline}</p>
        </div>
        <span className="link-arrow mt-2 shrink-0 text-white/70 transition-all duration-500 group-hover:translate-x-1 group-hover:text-gold">
          →
        </span>
      </div>
    </Link>
  );
}

export default function HomeDestinations() {
  const domestic = DESTINATIONS.filter((d) => d.region === "Domestic");
  const international = DESTINATIONS.filter((d) => d.region === "International");

  return (
    <section data-testid="home-destinations" className="bg-ink">
      <div className="mx-auto max-w-[1600px] px-6 py-28 lg:px-12 lg:py-40">
        <div className="grid items-end gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Reveal>
              <Label>Destinations</Label>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="mt-6 font-serif text-4xl font-light leading-[1.0] tracking-tight text-white sm:text-5xl lg:text-6xl">
                Where will you go next?
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-4 lg:col-start-9">
            <Reveal delay={0.15}>
              <p className="text-base leading-relaxed text-white/60">
                Discover destinations selected for their landscapes, culture, character
                and unforgettable experiences.
              </p>
            </Reveal>
          </div>
        </div>

        <Reveal>
          <p className="label mt-24 text-white/40">Domestic</p>
        </Reveal>
        <div className="mt-10 grid gap-14 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-7">
            <Reveal><Card d={domestic[0]} large /></Reveal>
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={0.12}><Card d={domestic[1]} offset /></Reveal>
          </div>
        </div>

        <Reveal>
          <p className="label mt-28 text-white/40">International</p>
        </Reveal>
        <div className="mt-10 grid gap-14 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-5">
            <Reveal><Card d={international[0]} /></Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={0.12}><Card d={international[1]} large offset /></Reveal>
          </div>
        </div>

        <Reveal delay={0.1}>
          <p className="mt-24 font-serif text-2xl font-light italic text-white/40">
            More destinations coming soon.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
